var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M8 2h8M8 3h8M6 4h2m8 0h8M6 5h2m8 0h8M6 6h2m16 0h2M6 7h2m16 0h2M6 8h2m10 0h2m4 0h2M6 9h2m10 0h2m4 0h2M4 10h2m12 0h4m2 0h2M4 11h2m12 0h4m2 0h2M4 12h2m8 0h6m2 0h2M4 13h2m8 0h6m2 0h2M4 14h2m8 0h2m8 0h2M4 15h2m8 0h2m8 0h2M2 16h2m4 0h8m8 0h2M2 17h2m4 0h8m8 0h2M2 18h2m4 0h2m4 0h6m2 0h2M2 19h2m4 0h2m4 0h6m2 0h2M2 20h2m4 0h2m8 0h4M2 21h2m4 0h2m8 0h4M4 22h4m10 0h2M4 23h4m10 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "gray",
    d: "M8 4h2M8 5h2M8 6h2M8 7h2M8 8h2M8 9h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3e4256",
    d: "M10 4h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12 4h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d0e8e8",
    d: "M14 4h2m-2 1h2m-2 1h2m6 0h2M14 7h2m6 0h2M14 8h2m6 0h2M14 9h2m6 0h2m-12 1h2m8 0h2m-12 1h2m8 0h2m-12 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b5c9c9",
    d: "M16 6h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-8 1h4m-4 1h4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9dadad",
    d: "M18 6h2m-2 1h2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d82020",
    d: "M20 12h2m-2 1h2m-4 1h4m-4 1h4m-6 1h4m-4 1h4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8263",
    d: "M16 14h2m-2 1h2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8e435c",
    d: "M22 14h2m-2 1h2m-4 1h4m-4 1h4m-4 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.13e54fb0d3f1394187284ec15eaddf09.svg";
export { ForwardRef as ReactComponent };